<h3>Available RCR Takedowns</h3>

@if (rcrTakedownResponseError) {
  <div class="message-container message-container--info">
    <span class="status-icon">
      <ng-container>
        <i class="fa fa-exclamation-circle status-icon--md"></i>
      </ng-container>
    </span>
    <div class="status-message">
      <span class="status-header">Status</span>
      <div class="status-content">{{ errorStr }}</div>
    </div>
  </div>
}

@if (takedownHasError) {
  <invd-rcr-exchange-error-message
    [title]="takedownErrorMessage.title"
    [description]="takedownErrorMessage.description"
    [suggestions]="takedownErrorMessage.suggestions"
  >
  </invd-rcr-exchange-error-message>
}

@if (showCutoffBanner) {
  <div class="message-container message-container--info">
    <span class="status-icon">
      <ng-container>
        <i class="fa fa-exclamation-circle status-icon--md"></i>
      </ng-container>
    </span>
    <div class="status-message">
      <span class="status-header">Status</span>
      <div class="status-content">{{ cutoffBannerMessage }}</div>
    </div>
  </div>
}

@if (!rcrTakedownResponseError) {
  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead>
        <tr class="th_row">
          <th class="th_column sortable-column">
            <span>Deal/Trust #</span>
            <a class="column-name" (click)="sortByGridByColumnName('dealNumber')">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'dealNumber'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'dealNumber'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column sortable-column">
            <a class="column-name" (click)="sortByGridByColumnName('displayDealType')">
              <a>Deal Type</a>
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'displayDealType'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'displayDealType'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">Status</th>
          <th class="th_column th_icon">View</th>
          <th class="th_column th_icon">Edit</th>
          <th class="th_column th_icon">Cancel</th>
          @if (isInternalUsr) {
            <th class="th_column th_icon">Delete</th>
          }
          <th class="th_column">Settlement Date</th>
        </tr>
      </thead>
      <tbody>
        @for (
          availableRcrTakedown of rcrTakedownData?.atSettlementDeals;
          track availableRcrTakedown;
          let j = $index
        ) {
          <tr class="td_row">
            <td class="td_cell">{{ availableRcrTakedown?.dealNumber }}</td>
            <td class="td_cell">{{ availableRcrTakedown?.displayDealType }}</td>
            <td class="td_cell" [ngClass]="getTakedownSubStatusClass(availableRcrTakedown)">
              {{ getTakedownSubStatus(availableRcrTakedown) }}
            </td>
            <td class="td_cell td_icon">
              <button
                type="button"
                class="takedown-icon button-takedown--transparent"
                [disabled]="availableRcrTakedown.takeDownStatus === 'NEW'"
                (click)="retrieveExchangeData(availableRcrTakedown)"
              >
                <i
                  class="fa fa-eye"
                  [ngClass]="{
                    'view-takedown-enable': availableRcrTakedown.takeDownStatus === 'SUBMITTED',
                    'icon-disable': availableRcrTakedown.takeDownStatus === 'NEW',
                  }"
                ></i>
              </button>
            </td>
            <td class="td_cell td_icon">
              <button
                class="takedown-icon button-takedown--transparent"
                type="button"
                [disabled]="
                  availableRcrTakedown?.noTakedownFlag ||
                  (availableRcrTakedown.takeDownStatus !== 'NEW' && !enableEdit) ||
                  isTakedownReadOnly(availableRcrTakedown)
                "
                (click)="takeDownClick(j)"
              >
                <i
                  class="fa fa-pencil-square-o"
                  [ngClass]="{
                    'icon-disable':
                      availableRcrTakedown?.noTakedownFlag ||
                      (availableRcrTakedown.takeDownStatus !== 'NEW' && !enableEdit) ||
                      isTakedownReadOnly(availableRcrTakedown),
                    'edit-takedown-icon-enable':
                      (!availableRcrTakedown?.noTakedownFlag ||
                        availableRcrTakedown.takeDownStatus === 'NEW' ||
                        enableEdit) &&
                      !isTakedownReadOnly(availableRcrTakedown),
                  }"
                ></i>
              </button>
            </td>
            <td class="td_cell td_icon">
              <button
                type="button"
                class="takedown-icon button-takedown--transparent"
                [disabled]="
                  (availableRcrTakedown.takeDownStatus === 'NEW' &&
                    !availableRcrTakedown?.noTakedownFlag) ||
                  isTakedownReadOnly(availableRcrTakedown)
                "
                (click)="cancelTakeDownClick(availableRcrTakedown)"
              >
                <i
                  class="fa fa-times-circle"
                  [ngClass]="{
                    'edit-takedown-icon-enable':
                      (availableRcrTakedown?.noTakedownFlag ||
                        availableRcrTakedown.takeDownStatus === 'SUBMITTED') &&
                      !isTakedownReadOnly(availableRcrTakedown),
                    'icon-disable':
                      (availableRcrTakedown.takeDownStatus === 'NEW' &&
                        !availableRcrTakedown?.noTakedownFlag) ||
                      isTakedownReadOnly(availableRcrTakedown),
                  }"
                ></i>
              </button>
            </td>
            @if (isInternalUsr) {
              <td class="td_cell td_icon">
                <button
                  class="takedown-icon button-takedown--transparent"
                  type="button"
                  [disabled]="
                    availableRcrTakedown?.noTakedownFlag ||
                    availableRcrTakedown.takeDownStatus === 'SUBMITTED'
                  "
                  (click)="reloadRecomClicked(availableRcrTakedown)"
                >
                  <i
                    class="fa fa-trash"
                    [ngClass]="{
                      'icon-disable':
                        availableRcrTakedown?.noTakedownFlag ||
                        availableRcrTakedown.takeDownStatus === 'SUBMITTED',
                      'edit-takedown-icon-enable':
                        !availableRcrTakedown?.noTakedownFlag ||
                        availableRcrTakedown.takeDownStatus === 'NEW',
                    }"
                  ></i>
                </button>
              </td>
            }
            <td class="td_cell">
              {{ formatDate(availableRcrTakedown?.dealSettlementDate) }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (cancelTakeDownModelWindow.show) {
    <div class="cancel-takedown-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="cancelTakeDownModelWindow.show = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          <h4>Are you sure you want to cancel this takedown?</h4>
          <p>
            You are about to cancel a takedown for <br />
            Deal {{ cancelTakeDownModelWindow.atSettlementDeals?.dealNumber }} (confirmation #{{
              cancelTakeDownModelWindow.atSettlementDeals?.exchangeConfirmationNumber
            }}).
          </p>
          <p>
            This action can not be undone. <br />
            To get it back you must request a new takedown.
          </p>
          <button
            class="button fm-tertiary-button"
            (click)="cancelTakeDownModelWindow.show = false"
          >
            NO
          </button>
          <button
            class="button fm-primary-button"
            #exchangeCancelledOnButtonClick
            (click)="callCancelExchangeService(cancelTakeDownModelWindow.atSettlementDeals)"
          >
            YES
          </button>
        </div>
      </div>
    </div>
  }

  @if (cancelTakeDownModelWindow.showCancelConfirmation) {
    <div class="cancel-takedown-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="cancelTakeDownModelWindow.showCancelConfirmation = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          <i class="fa fa-check-circle check-icon"></i>
          <h4>Your takedown is now cancelled</h4>
          <button
            class="button fm-primary-button"
            (click)="cancelTakeDownModelWindow.showCancelConfirmation = false"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  }

  @if (reloadTakeDownModelWindow.show) {
    <div class="reload-takedown-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="reloadTakeDownModelWindow.show = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          <h4 class="header-align">Are you sure you want to reload this takedown?</h4>
          <p>
            You are about to reload a takedown for <br />
            Deal {{ reloadTakeDownModelWindow.atSettlementDeals?.dealNumber }}.
          </p>
          <p>
            This action can not be undone. <br />
            To get it back you must request reprint.
          </p>
          <button
            class="button fm-tertiary-button"
            (click)="reloadTakeDownModelWindow.show = false"
          >
            NO
          </button>
          <button
            class="button fm-primary-button"
            #remicReloadOnButtonClick
            (click)="reloadRecomService(reloadTakeDownModelWindow.atSettlementDeals)"
          >
            YES
          </button>
        </div>
      </div>
    </div>
  }

  @if (reloadTakeDownModelWindow.showReloadconfirmation) {
    <div class="reload-takedown-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="reloadTakeDownModelWindow.showReloadconfirmation = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          @if (showReloadTakedownSuccessMsg) {
            <i class="fa fa-check-circle check-icon"></i>
          }
          @if (!showReloadTakedownSuccessMsg) {
            <i class="fa fa-exclamation-triangle error-icon"></i>
          }
          <p>{{ reloadTakeDownModelWindow?.ReloadConfirmationMessage }}</p>
          <button
            class="button fm-primary-button"
            (click)="reloadTakeDownModelWindow.showReloadconfirmation = false"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  }
}

@if (showDealerTraderModel) {
  <div class="edit-dealer-trader-model-window">
    <div class="panel panel-default">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="showDealerTraderModel = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 class="model-title">Select Dealer/Trader</h5>
      <div class="panel-body">
        <form class="dealer-trader-form" #f="ngForm" [formGroup]="requestExchangeForm">
          <!--******************************* Dealer Dropdown *******************************-->
          <h5>Dealer</h5>
          <div class="custom-select">
            <select
              [ngModel]="selectedDealer"
              formControlName="dealerControl"
              (ngModelChange)="onDealerSelect($event)"
            >
              <option disabled [ngValue]="null">Select dealer</option>
              @for (dealer of dealers; track dealer) {
                <option [ngValue]="dealer">
                  {{ dealer.dealerName }}
                </option>
              }
            </select>
          </div>
          <!--******************************* Dealer Dropdown *******************************-->

          <!--******************************* Approved Trader Dropdown *******************************-->
          @if (selectedDealer == null) {
            <h5 class="trader-pos">Approved Trader</h5>
            <div class="custom-select">
              <select
                class="custom-select"
                formControlName="traderControl"
                [ngModel]="selectedAssociatedTrader"
                (ngModelChange)="onTraderSelect($event)"
              >
                <option disabled [ngValue]="null">Select Approved Trader</option>
              </select>
            </div>
          }

          @if (selectedDealer != null) {
            <h5 class="trader-pos">Approved Trader</h5>
            <div class="custom-select">
              <select
                class="custom-select"
                formControlName="traderControl"
                [ngModel]="selectedAssociatedTrader"
                (ngModelChange)="onTraderSelect($event)"
              >
                <option disabled [ngValue]="null">Select Approved Trader</option>
                @for (trader of selectedDealer.traders; track trader) {
                  <option [ngValue]="trader">
                    {{ trader.traderFirstName + ' ' + trader.traderLastName }}
                  </option>
                }
              </select>
            </div>
          }

          <!--******************************* Approved Trader Dropdown *******************************-->
        </form>

        <div class="footer">
          <button
            class="button fm-primary-button"
            (click)="submitTraderDetails()"
            [disabled]="!(selectedDealer && selectedAssociatedTrader)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showTakedownModal) {
  <div class="warning-modal-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="panel-body">
        <p>{{ takedownModalMessage }}<br /></p>
        <h4>Do you wish to proceed?</h4>
        <br />
        <button class="button fm-tertiary-button" (click)="cancelTakedownModal()">NO</button>
        <button class="button fm-primary-button" (click)="submitWithoutTakedown()">YES</button>
      </div>
    </div>
  </div>
}
